<div *transloco="let t; prefix: scope" class="grid h-svh grid-cols-1 sm:h-auto sm:grid-cols-2">
  <div class="flex flex-col gap-6 p-8">
    <h2 class="text-heading-2" [innerHTML]="t('title')"></h2>

    <div>
      <p class="mb-4 text-steel-90">{{ t('blurb') }}</p>

      <p class="mb-2 text-steel-90">{{ t('benefits.header') }}</p>
      <ul rma-list>
        @for (benefit of benefits(); track $index) {
          <li rma-list-item bulletStyle="check">
            <span [innerHTML]="benefit"></span>
          </li>
        }
      </ul>
      <p class="mt-4 text-steel-90" [innerHTML]="t('benefits.footer')"></p>
    </div>
    @if (attract) {
      <rma-upgrade-button
        [overrideLock]="true"
        [tier]="tier"
        [interval]="interval"
        [redirectTo]="{} | appendReturnUrlParams"
        mat-dialog-close
        data-id="test-welcome-modal-click"
      />
    } @else {
      <rma-upgrade-button [overrideLock]="true" mat-dialog-close data-id="test-welcome-modal-click" />
    }
  </div>
  <div class="flex h-full justify-center bg-gradient-to-br from-[#0068FF] to-ai-100">
    <img alt="" class="object-contain" [src]="'subscription-primer/free-premium-plan.png' | staticImageUrl" />
  </div>
</div>
